/* Kyaro goodiebag V6 calendar. `defer`, AFTER goodiebag-core.js (works without it).
   Hooks: [data-gb-event] JSON; [data-gb-cal|direct|choose|dialog|close|ics|outlook|route|sticky]; #gb-route.
   Countdown [data-gb-countdown] data-target (epoch s), data-l1/ln, phase copy data-week|eve|today -> [data-gb-phase].
   Event over: html.gb-ended. */
(function () {
 'use strict';
 var G = window.KyaroGB = window.KyaroGB && typeof window.KyaroGB === 'object' ? window.KyaroGB : {};
 if (G.cal) return;
 G.cal = 1;
 var d = document, html = d.documentElement, ua = navigator.userAgent;
 var isIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
 var isApple = isIOS || /Macintosh/.test(ua);
 var isAndroid = !isApple && /Android/.test(ua);
 function $(s, r) { return (r || d).querySelector(s); }
 function $$(s, r) { return [].slice.call((r || d).querySelectorAll(s)); }
 function pad(n) { return (n < 10 ? '0' : '') + n; }
 function tzOffset(tz, ms) {
  var p = {};
  new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: 'numeric',
   day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = +x.value; });
  return (Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - ms) / 60000;
 }
 function offsetFor(e, local) {
  var m = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(local || '');
  if (!m) return null;
  var guess = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
  try {
   var off = tzOffset(e.tz, guess);
   return { ms: guess, off: tzOffset(e.tz, guess - off * 60000) };
  } catch (err) {
   var o = /([+-])(\d\d):?(\d\d)/.exec(e.offset || '+01:00');
   return { ms: guess, off: o ? (o[1] === '-' ? -1 : 1) * (o[2] * 60 + +o[3]) : 60 };
  }
 }
 function toUTC(e, local) { var r = offsetFor(e, local); return r ? r.ms - r.off * 60000 : NaN; }
 function fmtOff(m) { var a = Math.abs(m); return (m < 0 ? '-' : '+') + pad(Math.floor(a / 60)) + ':' + pad(a % 60); }
 function stamp(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d+/, ''); }
 function esc(s) {
  return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
 }
 function fold(line) {
  var out = '', n = 0, i = 0, c, w, b;
  while (i < line.length) {
   c = line.charCodeAt(i);
   w = c >= 0xD800 && c < 0xDC00 && (line.charCodeAt(i + 1) & 0xFC00) === 0xDC00 ? 2 : 1;
   b = w === 2 ? 4 : c < 128 ? 1 : c < 2048 ? 2 : 3;
   if (n + b > 75) { out += '\r\n '; n = 1; }
   out += line.substr(i, w);
   n += b;
   i += w;
  }
  return out;
 }
 function buildIcs(e, now) {
  var s = toUTC(e, e.start), t = toUTC(e, e.end), host = location.hostname || 'kyaro';
  var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kyaro//Goodiebag//NL', 'METHOD:PUBLISH',
   'BEGIN:VEVENT', 'UID:opening-' + stamp(s) + '@' + host, 'DTSTAMP:' + stamp(now || Date.now()),
   'DTSTART:' + stamp(s), 'DTEND:' + stamp(t), 'SUMMARY:' + esc(e.title),
   'LOCATION:' + esc(e.location), 'DESCRIPTION:' + esc(e.description)];
  if (e.url) L.push('URL:' + e.url);
  L.push('BEGIN:VALARM', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(e.title), 'TRIGGER:-P1D', 'END:VALARM',
   'END:VEVENT', 'END:VCALENDAR');
  return L.map(fold).join('\r\n') + '\r\n';
 }
 G.buildIcs = buildIcs;
 var S = { e: {} };
 function refresh() {
  try { S.e = JSON.parse($('[data-gb-event]').textContent); } catch (x) { S.e = {}; }
  S.end = toUTC(S.e, S.e.end);
  S.day = toUTC(S.e, String(S.e.start || '').slice(0, 10) + 'T00:00');
  S.bar = $('[data-gb-sticky]');
  S.cta = $('.gb-hero [data-gb-cal]');
  S.route = d.getElementById('gb-route');
  S.dlg = $('[data-gb-dialog]');
  clearTimeout(S.timer);
  var w = S.end - Date.now();
  if (w <= 0) html.classList.add('gb-ended');
  else if (w < 2147483647) S.timer = setTimeout(function () { html.classList.add('gb-ended'); sticky(); }, w + 50);
 }
 function saveIcs() {
  var e = S.e;
  // Hosted file: iOS shows its "Add to Calendar" sheet for a served text/calendar; macOS opens Calendar.app via webcal:.
  if (e.icsUrl) { location.href = isApple && !isIOS ? e.icsUrl.replace(/^https?:/, 'webcal:') : e.icsUrl; return; }
  var data = buildIcs(e), a = d.createElement('a'), url;
  if (isIOS) { location.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(data); return; }
  url = a.href = URL.createObjectURL(new Blob([data], { type: 'text/calendar;charset=utf-8' }));
  a.download = 'kyaro-opening.ics';
  d.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
 }
 function openChooser(btn) {
  var m = S.dlg;
  if (!m || !m.showModal) return false;
  m.addEventListener('close', function () { sticky(); if (btn.isConnected) btn.focus(); }, { once: true });
  m.showModal();
  sticky();
  return true;
 }
 d.addEventListener('click', function (e) {
  var t = e.target, m = S.dlg, el;
   if (t.closest('[data-gb-direct]')) {
   if (isApple) { e.preventDefault(); saveIcs(); }
   return;
  }
  if ((el = t.closest('[data-gb-cal]'))) {
   if (isApple) { e.preventDefault(); saveIcs(); }
   else if (!isAndroid && openChooser(el)) e.preventDefault();
   return;
  }
  if ((el = t.closest('[data-gb-choose]'))) { openChooser(el); return; }
  if (!m || !m.open) return;
  if (t.closest('[data-gb-ics]')) saveIcs();
  if (t.closest('[data-gb-close], [data-gb-ics]') || t === m) m.close();
  else if (t.closest('a.gb-opt')) setTimeout(function () { m.close(); }, 0);
 });
 function setup(root) {
  var e = S.e;
  $$('[data-gb-cal], [data-gb-direct]', root).forEach(function (a) {
   var cal = a.hasAttribute('data-gb-cal'), s = $('[data-gb-label]', a),
    l = isApple ? a.dataset.labelApple : (isAndroid || !cal) ? a.dataset.labelGoogle : '';
   if (l && s) { s.textContent = l; if (cal) a.removeAttribute('aria-label'); }
   if (cal && !isApple && !isAndroid) a.setAttribute('aria-haspopup', 'dialog');
  });
  var list = $('[data-gb-options]', root), g = list && $('[data-gb-opt="google"]', list);
  if (isAndroid && g) list.insertBefore(g, list.firstChild);
  var so = offsetFor(e, e.start), eo = offsetFor(e, e.end);
  if (so && eo) {
   $$('[data-gb-outlook]', root).forEach(function (a) {
    a.href = a.href
     .replace(/startdt=[^&]*/, 'startdt=' + encodeURIComponent(e.start + ':00' + fmtOff(so.off)))
     .replace(/enddt=[^&]*/, 'enddt=' + encodeURIComponent(e.end + ':00' + fmtOff(eo.off)));
   });
  }
  $$('[data-gb-route]', root).forEach(function (a) { if (isApple && a.dataset.apple) a.href = a.dataset.apple; });
  $$('[data-gb-countdown]', root).forEach(countdown);
 }
 function countdown(el) {
  if (el.gb) return;
  el.gb = 1;
  var target = +el.dataset.target * 1000, grid = $('[data-gb-grid]', el), open = $('[data-gb-open]', el),
   sr = $('[data-gb-sr]', el), ph = $('[data-gb-phase]', el), u = {}, timer, phased;
  $$('[data-u]', el).forEach(function (b) { u[b.dataset.u] = b; });
  function tick(live) {
   clearTimeout(timer);
   var now = Date.now(), r = Math.floor((target - now) / 1000), D = 864e5;
   if (ph) {
    var p = r <= 0 ? '' : now >= S.day ? 'today' : now >= S.day - D ? 'eve' : now >= S.day - 7 * D ? 'week' : '',
     t = (p && el.dataset[p]) || '';
    t = t.split('[dagen]').join(Math.ceil((S.day - now) / 864e5)); // calendar days to the event day
    ph.textContent = t;
    ph.hidden = !t;
    if (t && grid) { grid.hidden = true; phased = 1; } // phase line replaces the numbers
    else if (phased) { grid.hidden = false; phased = 0; }
   }
   if (r <= 0) {
    if (grid && (!grid.hidden || phased)) {
     phased = 0;
     grid.hidden = true;
     if (sr) sr.hidden = true;
     if (open) { if (live) open.setAttribute('role', 'status'); open.hidden = false; }
    }
    return;
   }
   var days = Math.floor(r / 86400), v = { d: days, dl: days === 1 ? el.dataset.l1 : el.dataset.ln,
    h: pad(Math.floor(r % 86400 / 3600)), m: pad(Math.floor(r % 3600 / 60)), s: pad(r % 60) };
   for (var k in v) if (u[k]) u[k].textContent = v[k];
   if (!d.hidden) timer = setTimeout(tick, u.s ? 1005 - Date.now() % 1000 : (r % 60 + 1) * 1000, 1);
  }
  d.addEventListener('visibilitychange', function () { if (!d.hidden) tick(1); else clearTimeout(timer); });
  tick(0);
 }
 var focus = false, raf = 0, mq = window.matchMedia && matchMedia('(max-width: 767px)');
 function bannerUp() {
  var b = d.getElementById('shopify-pc__banner');
  return !!(b && b.offsetHeight && getComputedStyle(b).visibility !== 'hidden');
 }
 function sticky() {
  raf = 0;
  var bar = S.bar, cta = S.cta, route = S.route, m = S.dlg;
  if (!bar || !cta) return;
  var c = cta.getBoundingClientRect();
  var near = !!route && route.getBoundingClientRect().top < innerHeight;
  var show = c.height > 0 && c.bottom < 0 && !near && !focus && !(m && m.open) && !(Date.now() > S.end) &&
   !!(mq && mq.matches) && !bannerUp();
  if (bar.classList.contains('is-shown') === show) return;
  bar.classList.toggle('is-shown', show);
  html.classList.toggle('gb-sticky-on', show);
  if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
 }
 function queue() { if (!raf) raf = requestAnimationFrame(sticky); }
 function initSticky() {
  if (!S.bar || (window.Shopify && Shopify.designMode)) return;
  if (S.bar.parentNode !== d.body) d.body.appendChild(S.bar);
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue, { passive: true });
  d.addEventListener('focusin', function (e) { focus = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName); queue(); });
  d.addEventListener('focusout', function () { focus = false; queue(); });
  d.addEventListener('visitorConsentCollected', function () { setTimeout(queue, 60); });
  queue();
 }
 html.classList.add('js-gb');
 refresh();
 setup(d);
 initSticky();
 d.addEventListener('shopify:section:load', function (e) { refresh(); setup(e.target); queue(); });
})();
